//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface ICancellationClient {
	/**
	 * Create a new pending cancellation and return a rating
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param body (optional)
	 * @return OK
	 */
	propose(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		body: CreateCancellationCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CancellationResponseDto>;
	/**
	 * Update a pending cancellation and return a rating
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param body (optional)
	 * @return OK
	 */
	amend(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		body: UpdateCancellationCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CancellationResponseDto>;
	/**
	 * Update a pending cancellation and return a rating
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param body (optional)
	 * @return OK
	 */
	reject(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		body: RejectCancellationCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<boolean>;
	/**
	 * Checks if a policy is eligible for cancellation.
	 * @param policyToken (optional)
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	isEligible(
		policyToken: string | undefined,
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<CancellationEligibilityResponse>;
	/**
	 * Confirm a cancellation
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param body (optional)
	 * @return OK
	 */
	confirm(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		body: ConfirmCancellationCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<boolean>;
	/**
	 * Checks if brand/product support cancellation
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	isProductAndBrandSupported(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<ProductBrandSupportedResponse>;
}

export class CancellationClient implements ICancellationClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? '';
	}

	/**
	 * Create a new pending cancellation and return a rating
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param body (optional)
	 * @return OK
	 */
	propose(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		body: CreateCancellationCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CancellationResponseDto> {
		let url_ = this.baseUrl + '/api/v1/Cancellation/Propose';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processPropose(_response);
			});
	}

	protected processPropose(response: AxiosResponse): Promise<CancellationResponseDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CancellationResponseDto>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<CancellationResponseDto>(null as any);
	}

	/**
	 * Update a pending cancellation and return a rating
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param body (optional)
	 * @return OK
	 */
	amend(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		body: UpdateCancellationCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CancellationResponseDto> {
		let url_ = this.baseUrl + '/api/v1/Cancellation/Amend';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processAmend(_response);
			});
	}

	protected processAmend(response: AxiosResponse): Promise<CancellationResponseDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CancellationResponseDto>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<CancellationResponseDto>(null as any);
	}

	/**
	 * Update a pending cancellation and return a rating
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param body (optional)
	 * @return OK
	 */
	reject(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		body: RejectCancellationCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<boolean> {
		let url_ = this.baseUrl + '/api/v1/Cancellation/Reject';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'DELETE',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processReject(_response);
			});
	}

	protected processReject(response: AxiosResponse): Promise<boolean> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<boolean>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<boolean>(null as any);
	}

	/**
	 * Checks if a policy is eligible for cancellation.
	 * @param policyToken (optional)
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	isEligible(
		policyToken: string | undefined,
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<CancellationEligibilityResponse> {
		let url_ = this.baseUrl + '/api/v1/Cancellation/IsEligible?';
		if (policyToken === null) throw new globalThis.Error("The parameter 'policyToken' cannot be null.");
		else if (policyToken !== undefined) url_ += 'policyToken=' + encodeURIComponent('' + policyToken) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processIsEligible(_response);
			});
	}

	protected processIsEligible(response: AxiosResponse): Promise<CancellationEligibilityResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CancellationEligibilityResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<CancellationEligibilityResponse>(null as any);
	}

	/**
	 * Confirm a cancellation
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param body (optional)
	 * @return OK
	 */
	confirm(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		body: ConfirmCancellationCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<boolean> {
		let url_ = this.baseUrl + '/api/v1/Cancellation/Confirm';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processConfirm(_response);
			});
	}

	protected processConfirm(response: AxiosResponse): Promise<boolean> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<boolean>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<boolean>(null as any);
	}

	/**
	 * Checks if brand/product support cancellation
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	isProductAndBrandSupported(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<ProductBrandSupportedResponse> {
		let url_ = this.baseUrl + '/api/v1/Cancellation/IsProductAndBrandSupported';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processIsProductAndBrandSupported(_response);
			});
	}

	protected processIsProductAndBrandSupported(response: AxiosResponse): Promise<ProductBrandSupportedResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ProductBrandSupportedResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ProductBrandSupportedResponse>(null as any);
	}
}

export interface IGatewayTestClient {
	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	pingForGatewayByControllerGet(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse>;
	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	pingForGatewayByControllerHead(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse>;
}

export class GatewayTestClient implements IGatewayTestClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? '';
	}

	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	pingForGatewayByControllerGet(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse> {
		let url_ = this.baseUrl + '/api/v1/GatewayTest/PingForGatewayByController';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processPingForGatewayByControllerGet(_response);
			});
	}

	protected processPingForGatewayByControllerGet(response: AxiosResponse): Promise<PingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PingResponse>(result200);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PingResponse>(null as any);
	}

	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	pingForGatewayByControllerHead(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse> {
		let url_ = this.baseUrl + '/api/v1/GatewayTest/PingForGatewayByController';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'HEAD',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processPingForGatewayByControllerHead(_response);
			});
	}

	protected processPingForGatewayByControllerHead(response: AxiosResponse): Promise<PingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PingResponse>(result200);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PingResponse>(null as any);
	}
}

export interface ITestClient {
	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	pingGet(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse>;
	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	pingHead(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse>;
	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param x_Custom_Header (optional) I'm a custom tenant header, set on a method
	 * @return OK
	 */
	pingForGatewayByMethodGet(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		x_Custom_Header: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse>;
	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param x_Custom_Header (optional) I'm a custom tenant header, set on a method
	 * @return OK
	 */
	pingForGatewayByMethodHead(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		x_Custom_Header: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse>;
}

export class TestClient implements ITestClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? '';
	}

	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	pingGet(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse> {
		let url_ = this.baseUrl + '/api/v1/Test/Ping';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processPingGet(_response);
			});
	}

	protected processPingGet(response: AxiosResponse): Promise<PingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PingResponse>(result200);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PingResponse>(null as any);
	}

	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @return OK
	 */
	pingHead(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse> {
		let url_ = this.baseUrl + '/api/v1/Test/Ping';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'HEAD',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processPingHead(_response);
			});
	}

	protected processPingHead(response: AxiosResponse): Promise<PingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PingResponse>(result200);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PingResponse>(null as any);
	}

	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param x_Custom_Header (optional) I'm a custom tenant header, set on a method
	 * @return OK
	 */
	pingForGatewayByMethodGet(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		x_Custom_Header: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse> {
		let url_ = this.baseUrl + '/api/v1/Test/PingForGatewayByMethod';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				'X-Custom-Header': x_Custom_Header !== undefined && x_Custom_Header !== null ? '' + x_Custom_Header : '',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processPingForGatewayByMethodGet(_response);
			});
	}

	protected processPingForGatewayByMethodGet(response: AxiosResponse): Promise<PingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PingResponse>(result200);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PingResponse>(null as any);
	}

	/**
	 * Ping endpoint which will return a response
	 * @param x_Product (optional) This will need to be set for product
	 * @param x_Tenant (optional) This will need to be set for Tenant separation
	 * @param x_Custom_Header (optional) I'm a custom tenant header, set on a method
	 * @return OK
	 */
	pingForGatewayByMethodHead(
		x_Product: string | undefined,
		x_Tenant: string | undefined,
		x_Custom_Header: string | undefined,
		cancelToken?: CancelToken,
	): Promise<PingResponse> {
		let url_ = this.baseUrl + '/api/v1/Test/PingForGatewayByMethod';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'HEAD',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				'X-Tenant': x_Tenant !== undefined && x_Tenant !== null ? '' + x_Tenant : '',
				'X-Custom-Header': x_Custom_Header !== undefined && x_Custom_Header !== null ? '' + x_Custom_Header : '',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processPingForGatewayByMethodHead(_response);
			});
	}

	protected processPingForGatewayByMethodHead(response: AxiosResponse): Promise<PingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PingResponse>(result200);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PingResponse>(null as any);
	}
}

/** Represents the result of an eligibility check for cancellation, including whether cancellation is allowed and an optional reason if it is not. */
export interface CancellationEligibilityResponse {
	/** Gets a value indicating whether the current policy meets the criteria for cancellation. */
	isEligible?: boolean;
	reason?: CancellationIneligibilityReason;
}

/** Specifies the reasons why a policy is ineligible for cancellation. */
export enum CancellationIneligibilityReason {
	PolicyCancelled = 'PolicyCancelled',
	PolicyPending = 'PolicyPending',
	PolicyExpired = 'PolicyExpired',
	PolicyInRenewalWindow = 'PolicyInRenewalWindow',
	PolicyHasOpenClaim = 'PolicyHasOpenClaim',
	PolicyHasFaultClaim = 'PolicyHasFaultClaim',
	PaymentRequested = 'PaymentRequested',
	ErrorCheckingEligibility = 'ErrorCheckingEligibility',
}

/** Cancellation rate response. Filtered down API.Core.Cancellation.Application.Common.Interfaces.CancellationsService.RateCancellationResponse to only the necessary fields needed. */
export interface CancellationRateResponse {
	/** Underwriting option id. */
	optionId: string | undefined;
	paymentType: PaymentType;
	/** Payment Option Code. */
	paymentOptionCode: string | undefined;
	/** Cancellation fee. */
	cancellationFee: number;
	/** Initial amount before applying the cancellation fee. */
	initialAmount: number;
	/** Final amount after applying the cancellation fee. Calculated as InitialAmount + CancellationFee. Always Positive. */
	finalAmount?: number;
	/** Insurance Premium Tax (IPT) applied to the policy. */
	insurancePremiumTax: number;
	/** When Api.Core.Cancellation.Application.Common.Models.CancellationRateResponse.PaymentType is Charge, this date becomes midnight of the day after the proposed cancellation date. */
	actualCancellationDate?: string | undefined;
	feeType?: FeeType;
}

/** The object returned by Update and Rate Cancellation */
export interface CancellationResponseDto {
	transactionId: string | undefined;
	rateData: CancellationRateResponse;
}

export interface ConfirmCancellationCommand {
	/** Existing policy reference */
	policyReference: string;
	/** The transactionId for this cancellation */
	transactionId: string;
	/** The option id provided as part of the rate payload */
	optionId: string;
	/** Payment Collection Option Code (AP for additional payment, RP for refund) */
	paymentCollectionOptionCode: string;
	/** Date the customer is cancelling their policy from */
	cancellationDate: string;
	/** Reason the customer is cancelling their policy, must map to ICE code if provided */
	cancellationReason: string;
}

export interface CreateCancellationCommand {
	/** The Policy Reference to Cancel */
	policyReference: string;
	/** When to cancel the policy */
	cancellationDate: string;
	/** Reason the customer is considering cancelling their policy, must map to ICE code */
	cancellationReason: string;
}

export enum FeeType {
	ArrangementFeeRefund = 'ArrangementFeeRefund',
	CancellationFee = 'CancellationFee',
}

export enum PaymentType {
	Refund = 'Refund',
	Charge = 'Charge',
}

/** Response model for ping endpoints */
export interface PingResponse {
	message?: string | undefined;
	timestamp?: string;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

/** A response detailing whether the brand and product are supported */
export interface ProductBrandSupportedResponse {
	isSupported?: boolean;
	reason?: string | undefined;
}

export interface RejectCancellationCommand {
	/** The Policy Reference to Cancel */
	policyReference: string;
	/** The transactionId for this cancellation */
	transactionId: string;
	/** Reason the customer is considering cancelling their policy, must map to ICE code */
	rejectionReason?: string | undefined;
}

export interface UpdateCancellationCommand {
	/** The Policy Reference to Cancel */
	policyReference: string;
	/** When to cancel the policy */
	cancellationDate: string;
	/** Reason the customer is considering cancelling their policy, must map to ICE code */
	cancellationReason: string;
	/** The transactionId for this cancellation */
	transactionId: string;
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
